






























import { Component } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';

@Component({ name: 'ManualFeesDeleteDialog' })
export default class extends SaascadaVueDialog {

    get feeName() {
        return ProductDetailsModule.currentManualFee.name;
    }

    async deleteFee() {
        await ProductDetailsModule.deleteManualFee();
        this.dialog = false;
    }

}
